import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, FileText, Share2, Award, TrendingUp, Check, ChevronDown, ChevronUp } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import { companyInfo, heroSlides, whyMowgi, serviceBoxes, insights, successStories, founder, experienceSection, PODCAST_API, COMPANY_LOGO } from '../data/mockData';
import { podcasts, podcastCategories } from '../data/mockData';
import WhatsAppFloatingButton from "../pages/WhatsAppFloatingButton";
import { Oval } from 'react-loader-spinner';




const HomePage = () => {
  const [isFounderExpanded, setIsFounderExpanded] = useState(false);
  const [podcasts, setPodcasts] = useState([]);
  const [loading2, setLoading2] = useState(true);
    const [clientLogos, setClientLogos] = useState([]);
    const [loading, setLoading] = useState(true);
  const reversedPodcasts = podcasts.slice().reverse();

  
    useEffect(()=>{
      setLoading2(true);
      fetch(COMPANY_LOGO)
        .then((res) => res.json())
        .then((data) => {
          setClientLogos(data);
          setLoading2(false)
        })
        .catch((err) => {
          console.error(err);
          setLoading2(false)
        });
    },[])
  
     useEffect(() => {
      fetch(PODCAST_API)
        .then((res) => res.json())
        .then((data) => {
        const formatted = data.map((item) => {
    const videoId = item.url?.split("v=")[1]?.split("&")[0];
    return {
      id: Number(item.id),
      title: item.Title,
      youtubeId: videoId
    };
  });
  
  setPodcasts(formatted);
  
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: 'spring', stiffness: 100, damping: 12 },
    },
  };

  const serviceIcons = {
    'FileText': FileText,
    'Share2': Share2,
    'Award': Award,
    'TrendingUp': TrendingUp,
  };
const [selectedPodcast, setSelectedPodcast] = useState(
  reversedPodcasts[0] || null
);


  return (
    <div className="min-h-screen">
      {/* Hero Section with Swiper */}
      <section className="h-screen relative">
      <div className="relative h-full w-full overflow-hidden">

  {/* Background Video (never moves, no lag) */}
  <video
    src="/assets/video.mp4"
    autoPlay
    muted
    playsInline
    loop
    preload="metadata"
    className="absolute inset-0 w-full h-full object-cover z-0"
  />

  {/* Dark Overlay */}
<div className="absolute inset-0 bg-black/80 z-[1] pointer-events-none"></div>

  {/* Background Patterns */}

  {/* Only TEXT is sliding — super smooth */}
  <Swiper
    modules={[Autoplay, Pagination]}
    slidesPerView={1}
    autoplay={{ delay: 5000, disableOnInteraction: false }}
    pagination={{ clickable: true }}
    loop
    speed={700}
    className="relative z-[3] h-full"
  >
    {heroSlides.map((slide, index) => (
      <SwiperSlide key={index}>
        <div className="h-full w-full flex items-center">
          <div className="w-full px-6 lg:px-16 xl:px-24">
            <div className="grid lg:grid-cols-2 gap-8 items-center min-h-[80vh] pt-20">
              
              <div className="space-y-8">
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
                  {slide.title}
                  <br />
                  <span className="text-blue-300">{slide.subtitle}</span>
                </h1>

                <p className="text-lg md:text-xl max-w-xl leading-relaxed text-gray-300">
                  {slide.description}
                </p>

                <div className="flex flex-wrap gap-4">
                  <Link to="/services" className="cta-button !bg-white !text-navy hover:!bg-gray-100">
                    Explore Services
                  </Link>
                  <Link to="/contact" className="btn-ghost">
                    Let's Build Influence
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
 <WhatsAppFloatingButton />
</div>

        <style>{`
          .swiper-pagination-bullet {
            background: white;
            opacity: 0.5;
            width: 10px;
            height: 10px;
          }
          .swiper-pagination-bullet-active {
            background: white;
            opacity: 1;
          }
        `}</style>
      </section>

      {/* Why MOWGI Section */}
      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
            className="grid lg:grid-cols-2 gap-16 items-start"
          >
            <motion.div variants={itemVariants} className="space-y-6">
              <span className="service-tag bg-light-blue text-royal-blue">{whyMowgi.title}</span>
              <h2 className="text-4xl md:text-5xl font-bold leading-tight text-navy">
                {whyMowgi.headline}
              </h2>
              <p className="text-lg text-steel-blue leading-relaxed">
                {whyMowgi.description}
              </p>
              <Link to="/about" className="inline-flex items-center text-royal-blue font-semibold group">
                Learn more about us
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>

            <motion.div variants={itemVariants} className="space-y-8">
              <div>
                <h3 className="text-xl font-bold text-navy mb-6">{whyMowgi.subheadline}</h3>
                <ul className="space-y-4">
                  {whyMowgi.points.map((point, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="w-6 h-6 rounded-full bg-sage-light flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-sage" />
                      </div>
                      <span className="text-steel-blue">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-ice-blue p-6 rounded-lg border border-blue-100">
                <p className="text-lg font-semibold text-navy italic">"{whyMowgi.tagline}"</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Service Boxes */}
      <section className="py-24 lg:py-32 bg-snow">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 ">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
          >
            <motion.div variants={containerVariants} className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {serviceBoxes.map((service, index) => {
                const Icon = serviceIcons[service.icon];
                const colors = ['bg-light-blue', 'bg-sage-light', 'bg-amber-light', 'bg-ice-blue'];
                return (
                  <motion.div
                    key={index}
                    variants={itemVariants}
                    className={`${colors[index]} p-8 rounded-lg card-hover text-center`}
                  >
                    <div className="w-14 h-14 rounded-lg bg-white mx-auto mb-4 flex items-center justify-center shadow-sm">
                      <Icon className="w-7 h-7 text-royal-blue" />
                    </div>
                    <p className="ont-semibold text-navy max-w-2xl mx-auto">{service.label}</p>
                  </motion.div>
                );
              })}
            </motion.div>

            <motion.div variants={itemVariants} className="text-center mt-12">
              <Link to="/services" className="cta-button">
                View All Services
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Our Experience - Client Logos */}
      {/* <section className="py-20 bg-white border-y border-gray-100">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
            className="text-center"
          >
            <motion.div variants={itemVariants}>
              <span className="service-tag bg-light-blue text-royal-blue">{experienceSection.title}</span>
              <p className="text-steel-blue mt-4 max-w-2xl mx-auto">{experienceSection.description}</p>
            </motion.div>
            
            <motion.div variants={itemVariants} className="flex flex-wrap justify-center items-center gap-8 lg:gap-16 mt-12">
              {clientLogos.map((client, index) => (
                <img 
                  key={index}
                  src={client.logo} 
                  alt={client.name} 
                  className="h-12 lg:h-14 object-contain client-logo" 
                />
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section> */}
       <section className="py-20 bg-white border-y border-gray-100">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once:true, margin: "-100px" }}
            variants={containerVariants}
            className="text-center"
          >
            <motion.div variants={itemVariants}>
              <span className="service-tag bg-light-blue text-royal-blue">
                {experienceSection.title}
              </span>
              <p className="text-steel-blue mt-4 max-w-2xl mx-auto">
                {experienceSection.description}
              </p>
            </motion.div>
      
            {/* AUTO SCROLL LOGO WRAPPER */}
          <motion.div variants={itemVariants} className="relative overflow-hidden mt-12">
 <div className="flex items-center gap-20 animate-scroll">
 {clientLogos.concat(clientLogos).map((client, index) => (
 <div
 key={index}
 className="w-56 h-32 flex items-center justify-center"
 >
 <img
 src={`${client.image_url}`}
 alt={client.title}
 className="max-w-full max-h-full object-contain"
 />
 </div>
 ))}
 </div>
</motion.div>
          </motion.div>
             <div style={{
                display:"flex",
                justifyContent:"center",
                alignItems:"center",
                marginBottom:"20px"
              }}>
              {loading2 &&  <Oval
                height={80}
                width={80}
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#4fa94d"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
          }
          </div>
        </div>
      </section>

      {/* Client Success Stories */}
      <section className="py-24 lg:py-32 bg-navy text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
          >
            <motion.div variants={itemVariants} className="text-center mb-16">
              <span className="service-tag bg-light-blue text-royal-blue">Success Stories</span>
              <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6">Client Success Stories</h2>
            </motion.div>

            <motion.div variants={containerVariants} className="grid md:grid-cols-3 gap-8">
              {successStories.map((story, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  className="border border-white/20 p-8 rounded-lg hover:border-white/40 transition-colors bg-white/5"
                >
                  <h3 className="text-xl font-bold mb-4 text-blue-300">{story.title}</h3>
                  <p className="text-gray-300 leading-relaxed">{story.description}</p>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Latest Insights Preview */}
      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
          >
            <motion.div variants={itemVariants} className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
              <div>
                <span className="service-tag bg-amber-light text-amber">Latest</span>
                <h2 className="text-4xl md:text-5xl font-bold mt-4 text-navy">Industry Insights</h2>
              </div>
              <Link to="/insights" className="inline-flex items-center text-royal-blue font-semibold mt-4 md:mt-0 group">
                View All Insights
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>

            <motion.div variants={containerVariants} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {insights.slice(0, 3).map((insight) => (
                <motion.a
                  key={insight.id}
                  href={insight.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  variants={itemVariants}
                  className="group block rounded-lg overflow-hidden card-hover bg-snow border border-gray-100"
                >
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={insight.image}
                      alt={insight.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <span className="service-tag bg-light-blue text-royal-blue mb-3">{insight.category}</span>
                    <h3 className="font-semibold text-lg text-navy group-hover:text-royal-blue transition-colors">
                      {insight.title}
                    </h3>
                    <p className="text-silver text-sm mt-2">{insight.date}</p>
                    <span className="inline-flex items-center text-royal-blue text-sm font-semibold mt-4 group-hover:underline">
                      Read More <ArrowRight className="w-3 h-3 ml-1" />
                    </span>
                  </div>
                </motion.a>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>
{/* Latest Episodes Preview */}
<section className="py-24 lg:py-32 bg-snow">
  <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-100px' }}
      variants={containerVariants}
    >
      
      <motion.div
        variants={itemVariants}
        className="flex flex-col md:flex-row md:items-end md:justify-between mb-12"
      >
        <div>
          <span className="service-tag bg-light-blue text-royal-blue">Latest</span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 text-navy">
            Latest Podcasts
          </h2>
        </div>

       <Link
  to="/podcasts"
  className="inline-flex items-center text-royal-blue font-semibold mt-4 md:mt-0 group"
>
  View All Podcasts
  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
</Link>

      </motion.div>

     
      <motion.div
        variants={containerVariants}
        className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
      >

        {reversedPodcasts.slice(0, 3).map((podcast) => (
          <motion.div
            key={podcast.id}
            variants={itemVariants}
            className="group rounded-lg overflow-hidden card-hover bg-white border border-gray-100 cursor-pointer"
            onClick={() => setSelectedPodcast(podcast)}
          >
            {/* Thumbnail */}
            <div className="aspect-video relative overflow-hidden">
      <iframe
        className="w-full h-full"
        src={`https://www.youtube.com/embed/${podcast.youtubeId}`}
        title={podcast.title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>

        
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
       <div style={{
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      marginBottom:"20px"
    }}>
    {loading &&  <Oval
      height={80}
      width={80}
      color="#4fa94d"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
      ariaLabel='oval-loading'
      secondaryColor="#4fa94d"
      strokeWidth={2}
      strokeWidthSecondary={2}
    />
}
</div>
  </div>
</section>



      {/* Meet Our Founder */}
      {/* <section className="py-24 lg:py-32 bg-ice-blue">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
          >
            <motion.div variants={itemVariants} className="text-center mb-12">
              <span className="service-tag bg-royal-blue text-white">Leadership</span>
              <h2 className="text-4xl md:text-5xl font-bold mt-4 text-navy">Meet Our Founder</h2>
            </motion.div>

            <motion.div variants={itemVariants} className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg p-8 md:p-12 shadow-sm border border-gray-100">
                <div className="flex flex-col md:flex-row items-start gap-8">
                  <div className="w-32 h-32 rounded-lg bg-light-blue overflow-hidden flex-shrink-0">
                    <img
                      src={founder.image}
                      alt={founder.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-grow">
                    <h3 className="text-2xl font-bold text-navy mb-1">{founder.name}</h3>
                    <p className="text-steel-blue mb-4">{founder.title}</p>
                    
                    <div className="prose prose-slate max-w-none">
                      <p className="text-steel-blue leading-relaxed">
                        {founder.shortBio}
                      </p>
                      
                      {isFounderExpanded && (
                        <motion.div
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: 'auto' }}
                          exit={{ opacity: 0, height: 0 }}
                          className="mt-4 space-y-4"
                        >
                          {founder.fullBio.split('\n\n').slice(1).map((paragraph, index) => (
                            <p key={index} className="text-steel-blue leading-relaxed">
                              {paragraph}
                            </p>
                          ))}
                        </motion.div>
                      )}
                    </div>
                    
                    <button
                      onClick={() => setIsFounderExpanded(!isFounderExpanded)}
                      className="mt-4 inline-flex items-center text-royal-blue font-semibold hover:underline"
                    >
                      {isFounderExpanded ? (
                        <>Read Less <ChevronUp className="w-4 h-4 ml-1" /></>
                      ) : (
                        <>Read More <ChevronDown className="w-4 h-4 ml-1" /></>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-24 lg:py-32 bg-royal-blue">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
            className="text-center"
          >
            <motion.div variants={itemVariants}>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white">
                Ready to Build Influence?
              </h2>
              <p className="text-blue-100 text-lg max-w-2xl mx-auto mb-8">
                Let's craft campaign-driven strategies that align your brand with market-moving themes.
              </p>
              <Link to="/contact" className="cta-button !bg-white !text-royal-blue hover:!bg-gray-100">
                Let's Connect
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
